// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ButtonFormWrapper_buttonWrapper__KkAsz"};